import React from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { elementFieldTypeEnums } from './elementFieldTypes';
import Link from '../../components/Link';
import { countries } from '../countries/countries';
import { format } from 'date-fns';
import Dash from '@/dashboard/components/Dash';

export default function renderFieldValue(field) {
  if (!field.value) return <Dash />;

  switch (field.element) {
    case elementFieldTypeEnums.EMAIL:
      return (
        <Link to={`mailto:${field.value}`} target="_blank" variant="withIcon">
          <EnvelopeIcon className="h-4 w-4 mt-0.5" />
          {field.value}
        </Link>
      );
    case elementFieldTypeEnums.CHECKBOX:
      return field.value === 'true' ? 'Yes' : 'No';
    case elementFieldTypeEnums.COUNTRY: {
      const country = countries.find(country => country.alpha2 === field.value);

      if (!country) return field.value;

      return `${country.name} (${country.alpha2})`;
    }
    case elementFieldTypeEnums.DATE_TIME:
      return format(new Date(field.value), 'd MMM, yyyy, HH:mm');
    case elementFieldTypeEnums.DATE:
      return format(new Date(field.value), 'd MMM, yyyy');
    default:
      return field.value;
  }
}
